module.exports = __webpack_public_path__ + "img/cupcake-2.94c91979.svg";